<template>
    <div id="chatWindow" :class="{'isCallActive': this.call && chatWindowStatus == 3}">
        <div class="container"  @dragover="dragover">
            <loading-animation v-if="isLoading" :shown="isLoading" />
            <Header :currentType="currentType.text" :chatWindowStatus="chatWindowStatus" @closeChat="closeChat" />
            <div :class="{'content': true}" ref="content">
                <DropFile v-if="this.dragActive && threadState === 'open'" :dragActive="dragActive" @dragActive="toggleDrag" />
                <component v-else :is="componentMap[chatWindowStatus].component" @closeChat="closeChat" />
                <div class="typingAnimation" v-if="agent.isTyping"></div>
            </div>
            <ChatFooter v-if="chatWindowStatus == 3" />
        </div>
        <vue-confirm-dialog id="ChatVueDialog">
        </vue-confirm-dialog>
    </div>

</template>

<script>

import SendMessage from './SendMessage.vue'
import OfflineMessageForm from "./OfflineMessageForm";
import SatisfactionPoll from "./SatisfactionPoll";
import SelectOperator from "./SelectOperator";
import SelectSubject from './ChatContent/SelectSubject.vue';
import ChatFooter from './ChatContent/ChatFooter.vue';
import Header from './ChatContent/Header/index.vue';
import { EventBus } from '@/event-bus';
import DropFile from './DropFile.vue';

import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import LoadingAnimation from "@/components/LoadingAnimation";
import Conversation from './ChatContent/Conversation.vue';
import QueueView from './ChatContent/QueueView.vue';
import WaitingView from './ChatContent/WaitingView.vue';
import { changeChatWindowStatus } from '../utils';
import { confirmDiscard } from '@/services/offlineFormDraft';

export default {
    name: 'ChatWindow',
    components: {
        LoadingAnimation,
        SendMessage,
        OfflineMessageForm,
        SatisfactionPoll,
        SelectOperator,
        SelectSubject,
        Conversation,
        ChatFooter,
        QueueView,
        WaitingView,
        Header,
        DropFile
    },
    data() {
        return {
            selectedFile: null,
            imageFile: null,
            headerHeight: 0,
            footerHeight: 0,
            componentMap: {
                1: { component: 'select-subject' },
                3: { component: 'conversation' },
                4: { component: 'offline-message-form' },
                5: { component: 'select-operator' },
                6: { component: 'waiting-view' },
            },
            isSatisfactionPollVisible: false,
            isDisabled: false, 
            form: false,
            showmessage: true
        };
    },

    mounted() {
        this.calculateHeights();
        setTimeout(() => {
            this.calculateHeights();
        }, 100);

        this.$store.commit("setOperators", []);
        EventBus.$on('satisfactionPollShown', this.scrollToEnd);
        EventBus.$on('openConfirmDialog', this.openConfirmDialog);
        EventBus.$on('scrolltoend', this.scrollToEnd);

        let one_hour = 3600000; // one hour in timestamp

        // Si el chat no ha sido calificado y el estado del hilo es 'closed', y el chat está cerrado,
        // y han pasado más de una hora desde que se cerró el chat, entonces vuelve al menú
        if(!this.chatRated &&  this.threadState == 'closed' && this.chatWindowStatus == 3 && ((Date.now() - this.closeChatTime) > one_hour || this.closeChatTime === null)){
          this.$store.commit('setContactPhone', null);
          this.$store.commit('setOpeningHours', null);
          this.$store.commit('setClosingHours', null);
          changeChatWindowStatus(1);
        }
    },
    updated() {
        this.$nextTick(() => { this.calculateHeights() });
        if (this.chatWindowStatus == 3) {
            this.scrollToEnd();
        }
    },
    methods: {
        ...mapMutations([ "setChatOpen", 'incrementUserMessagesCount', 'updateDrag', 'showCallForm', 'updateCall', 'setCloseChatTime']),
        ...mapActions(['sendUserMessage', 'closeCurrentChat', 'shareCartWithAgent']),
        closeChatWindow() {
            this.setChatOpen(false);
        },
        dragover(e) {
            e.preventDefault();
            if(this.chatWindowStatus == 3){
                this.updateDrag(true)
            };
        },
        getMessage(event) {
            if (event.shiftKey===true && event.key === "Enter") {
                return;
            }

            if (this.message.length > 0) {
                this.sendUserMessage(this.message);
                this.message = "";
            }
        },
        toggleDrag(active){
            this.dragActive = active;
        },
        filesActive(event){
            event.preventDefault();
            if(this.dragActive == false){
                this.dragActive = true;
            }else if(this.dragActive == true){
                this.dragActive = false
            }
        },
        enterKeyDown(event){
            if (event.key === "Enter" && !event.shiftKey){
                event.preventDefault();
            }
        },
        onFileSelected(event) {
            this.selectedFile = event.target.files[0];
            // EXEC onUpload
            // console.log(this.selectedFile);
        },

        handlePollShown() {
            this.scrollToEnd();
        },
        onUpload() {
            const fd = new FormData();
            fd.append('file', this.selectedFile.name);
            // API uploadFile
            // console.log(fd);
        },
        scrollToEnd() {
            this.$nextTick(() => {
                let container = this.$refs.content;
                if (container) {
                    requestAnimationFrame(() => {
                        let scrollHeight = container.scrollHeight;
                        container.scrollTo({
                            top: scrollHeight,
                            behavior: 'smooth'
                        });
                    });
                }
            });
        },
        discardChatState() {
            this.showCallForm(false);
            this.updateDrag(false);
            this.closeCurrentChat(true);
            this.form = false;
            this.showmessage = true;
            this.$store.state.config = null;
            this.setCloseChatTime(null);
        },
        closeChat() {
            if (this.threadState !== 'open') {
                // Leaving the offline form discards the draft, same as Cancel.
                if (this.chatWindowStatus === 4) {
                    confirmDiscard(
                        this,
                        this.$gettext('¿Seguro que quieres salir? Se perderán los datos del formulario.'),
                        () => this.discardChatState()
                    );
                    return;
                }
                this.discardChatState();
                return;
            }
            this.$confirm(
                {
                    message: this.$gettext(`¿Estás seguro de que quieres salir del chat?`),
                    button: {
                        no: this.$gettext('No'),
                        yes: this.$gettext('Sí')
                    },
                    callback: confirm => {
                        if (confirm) {
                            if(this.closeChatTime !== null){
                              this.setCloseChatTime(Date.now());
                            }
                            this.updateCall(false);
                            this.closeCurrentChat();
                            this.message = "";
                        }
                    }
                },
            ) // Add a comma here
        },
        calculateHeights() {
            if (this.$refs['footer'] != undefined) {
                this.footerHeight = this.$refs['footer'].offsetHeight;
            } else {
                this.footerHeight = 0;
            }
            if (this.$refs['header'] != undefined) {
                this.headerHeight = this.$refs['header'].offsetHeight;
            } else {
                this.headerHeight = 0;
            }
        },
        async autoSelectSingleGroup() {
            // Guard in sessionStorage (not component data) so closing + reopening
            // the widget doesn't re-inject a single-group client into a new chat.
            if (sessionStorage.getItem('vc_hasAutoSelected') === '1') return;
            if (this.chatTypes.length !== 1 || this.appointmentUrls.length !== 0) return;

            sessionStorage.setItem('vc_hasAutoSelected', '1');

            const type = this.chatTypes[0];

            this.$store.commit('setContactPhone', type.contact_phone);
            this.$store.commit('setOpeningHours', type.opening_hour);
            this.$store.commit('setClosingHours', type.closing_hour);
            this.$store.commit('setSelectedGroupGotCamera', this.groupsWithCamera.includes(type.id));

            if (type.choose_operator) {
                EventBus.$emit('operatorsListed');
                await this.$store.http.checkForOperators(type.id);
                await this.$store.commit('setChatType', 0);

                if (this.operators.length === 0 || this.isChatAvailable === false) {
                    this.$store.commit('changeChatWindowStatus', 4);
                } else {
                    this.$store.commit('changeChatWindowStatus', 5);
                }
            } else {
                await this.$store.http.createThread(type.id, 0);
            }
        },
        openConfirmDialog({ message, callback }) {

          // Aquí llamamos a `this.$confirm` que abre el diálogo de confirmación
          this.$confirm({
            message: this.$gettext('Lo sentimos, tu acceso al videochat está restringido hasta el:')+ ' ' + this.bannedTill,
            button: {
              yes: this.$gettext('Aceptar')
            },
            callback: callback
          });
        }
    },

    computed: {
        ...mapState(['showLoading', 'config', 'chatWindowStatus','thread', 'chatWindowStatuses', 'user', 'chatTypes', 'chatType', 'waitingList', 'messages', 'agentMessagesCount', 'userMessagesCount', 'operators', 'call', 'callForm', 'dragActive', 'agent', "bannedTill", "closeChatTime", 'appointmentUrls', 'groupsWithCamera', 'isChatAvailable']),
        ...mapGetters(['messages', 'chatRated', 'threadState', 'isUserLogged', 'chatWindowStatusType', 'shareCartAvailable', 'cartInfo', 'defaultResponses']),
        // Empty object when no group has markets (all disabled), so the render does not break.
        currentType() {
            return this.chatTypes[this.chatType] || {};
        },
        currentComponent() {
            const mapping = this.componentMap[this.chatWindowStatus];
            if (!mapping) return null;
            return {
                name: mapping.component,
                props: mapping.props ? mapping.props() : {},
            };
        },
        isLoading() {
            return this.$store.state.showLoading;
        }
    },
    watch: {
        chatTypes: {
            immediate: true,
            handler() {
                if (this.chatWindowStatus === 1) {
                    this.autoSelectSingleGroup();
                }
            }
        },
        messages(newVal, oldVal) {
            if (newVal.length > oldVal.length) {
                this.scrollToEnd();
            }
        },
        isSatisfactionPollVisible(newVal) {
            if (newVal) {
                this.scrollToEnd();
            }
        },
        callForm(){
          this.scrollToEnd();
        },
        call(){
            setTimeout(() => {
              this.scrollToEnd();
            },500)
          }
    },
    beforeDestroy() {
        EventBus.$off('openConfirmDialog', this.openConfirmDialog);
        EventBus.$off('scrolltoend', this.scrollToEnd);
    },
}
</script>
